export default __webpack_public_path__ + "static/media/12-min.eeefc38f.PNG";